import { Ng2StateDeclaration } from '@uirouter/angular';
import { SimsConfigurationComponent } from './containers/sims-configuration/sims-configuration.component';
import { SimsOverviewComponent } from './containers/sims-overview/sims-overview.component';
import { SimOverviewDetailsComponent } from './containers/sim-overview-details/sim-overview-details.component';


export const simsConfigurationState: Ng2StateDeclaration = {
    name: 'sim-config-list',
    url: '/project/:projectId/sims/configuration',
    component: SimsConfigurationComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const simsOverviewState: Ng2StateDeclaration = {
    name: 'sim-overview',
    url: '/project/:projectId/sims/overview',
    component: SimsOverviewComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const simOverviewDetailsState: Ng2StateDeclaration = {
    name: 'sim-overview-detail',
    url: '/project/:projectId/sims/overview/:iccid?from&to',
    component: SimOverviewDetailsComponent,
    params: {
        projectId: {squash: true, value: null},
        iccid: {squash: true, value: null},
        from: {squash: true, value: null},
        to: {squash: true, value: null}
    }
};

export const SIMS_STATES = [
    simsConfigurationState,
    simsOverviewState,
    simOverviewDetailsState
];
